<template>
  <div class="content-message">
    <div class="top">
      <div class="back" @click="back">
        <img src="@/assets/img/icon_return.png" alt="">
        <div class="back-text">返回</div>
      </div>
      <div class="title">{{ type == 2 ? '修改规则' : '新增规则' }}</div>
    </div>
    <div class="form">
      <div class="form-item">
        <div class="form-item-text">
          规则名称
        </div>
        <el-input class="input" size="small" v-model="form.ruleName" placeholder="请输入"></el-input>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            包含省份
          </div>
          <el-select
            multiple
            filterable
            allow-create
            default-first-option
            v-model="form.province" placeholder="请选择" style="width: 100%;" size="small">
            <el-option
              v-for="item in provinceList"
              :key="item"
              :label="item"
              :value="item"
              size="small">
            </el-option>
          </el-select>
        </div>
        <div class="form-item-div">
          <div class="form-item-text">
            不包含省份
          </div>
          <el-select v-model="form.notProvince"
                     multiple
                     filterable
                     allow-create
                     default-first-option
                     placeholder="请选择" style="width: 100%;" size="small">
            <el-option
              v-for="item in provinceList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            包含城市
          </div>
          <el-select v-model="form.city"
                     multiple
                     filterable
                     allow-create
                     default-first-option
                     placeholder="请选择" style="width: 100%;" size="small">
            <el-option
              v-for="item in cityList"
              :key="item.id"
              :label="item.regionName"
              :value="item.regionName">
            </el-option>
          </el-select>
        </div>
        <div class="form-item-div">
          <div class="form-item-text">
            不包含城市
          </div>
          <el-select v-model="form.notCity"
                     multiple
                     filterable
                     allow-create
                     default-first-option
                     placeholder="请选择" style="width: 100%;" size="small">
            <el-option
              v-for="item in cityList"
              :key="item.id"
              :label="item.regionName"
              :value="item.regionName">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            包含影片
          </div>
          <el-select
            multiple
            filterable
            allow-create
            default-first-option
            v-model="form.movie" placeholder="请选择" style="width: 100%;" size="small">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="form-item-div">
          <div class="form-item-text">
            不包含影片
          </div>
          <el-select
            multiple
            filterable
            allow-create
            default-first-option
            v-model="form.notMovie" filterable placeholder="请选择" style="width: 100%;"
            size="small">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div" style="width: 100%;">
          <div class="form-item-text">
            座位数量
          </div>
          <div class="form-item-input">
            <div class="text">≥</div>
            <el-input style="width: 120px;margin-right: 8px" placeholder="请输入" size="small"
                      v-model="form.seatCount"></el-input>
            <div class="text">≤</div>
            <el-input style="width: 120px;margin-right: 8px" placeholder="请输入" size="small"
                      v-model="form.seatCountMax"></el-input>
            <div class="text">张</div>
            <el-radio v-model="form.seatEven" :label="0">全部</el-radio>
            <el-radio v-model="form.seatEven" :label="1">单数</el-radio>
            <el-radio v-model="form.seatEven" :label="2">双数</el-radio>
          </div>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            市场价
          </div>
<!--          <div class="flex" v-if="type ==2">-->
<!--            <el-input placeholder="请输入" size="small" v-model="form.minMarketPriceBig"></el-input>-->
<!--            <div class="icon">~</div>-->
<!--            <el-input placeholder="请输入" size="small" v-model="form.maxMarketPriceBig"></el-input>-->
<!--          </div>-->
          <div class="flex">
            <el-input placeholder="请输入" size="small" v-model="form.minMarketPrice"></el-input>
            <div class="icon">~</div>
            <el-input placeholder="请输入" size="small" v-model="form.maxMarketPrice"></el-input>
          </div>
        </div>
        <div class="form-item-div">
          <div class="form-item-text">
            情侣座
          </div>
          <el-radio v-model="form.containLove" :label="0">可含</el-radio>
          <el-radio v-model="form.containLove" :label="1">不含</el-radio>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            包含影院
          </div>
          <el-select
            multiple
            filterable
            allow-create
            default-first-option
            v-model="form.cinemaName" filterable placeholder="请选择" style="width: 100%;"
            size="small">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </div>
        <div class="form-item-div">
          <div class="form-item-text">
            不包含影院
          </div>
          <el-select
            multiple
            filterable
            allow-create
            default-first-option
            v-model="form.notCinemaName" filterable placeholder="请选择"
            style="width: 100%;" size="small">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            包含影厅
          </div>
          <el-select
            multiple
            filterable
            allow-create
            default-first-option
            v-model="form.hallName" filterable placeholder="请选择" style="width: 100%;"
            size="small">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </div>
        <div class="form-item-div">
          <div class="form-item-text">
            不包含影厅
          </div>
          <el-select
            multiple
            filterable
            allow-create
            default-first-option
            v-model="form.notHallName" filterable placeholder="请选择"
            style="width: 100%;" size="small">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            开场时间
          </div>
          <div class="form-item-input">
            <div class="text">≥</div>
            <el-input style="margin-right: 8px;width: 260px;" placeholder="请输入" size="small"
                      v-model="form.showTime"></el-input>
            <div class="text" style="width: 50px;">分钟</div>
          </div>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            假连锁影院
          </div>
          <el-select
            multiple
            filterable
            allow-create
            default-first-option
            v-model="form.fakeCinemaName" filterable placeholder="请选择"
                     style="width: 100%;" size="small">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </div>
        <div class="form-item-div">
          <div class="form-item-text">
            放映日期
          </div>
          <!--          <el-select filterable allow-create v-model="form.startDateBegin" filterable placeholder="请选择"-->
          <!--                     style="width: 100%;" size="small">-->
          <!--            <el-option-->
          <!--              v-for="item in options"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <el-date-picker
            v-model="startDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            value-format="yyyy-MM-dd"
          @change="getStartDate">
          </el-date-picker>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            放映时间
          </div>
          <!--          <el-select filterable allow-create v-model="form.startDateEnd" filterable placeholder="请选择"-->
          <!--                     style="width: 100%;" size="small">-->
          <!--            <el-option-->
          <!--              v-for="item in options"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value"-->
          <!--              size="small">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <el-select
            v-model="form.hourStart" filterable placeholder="请选择"
            style="width: 200px;" size="small">
            <el-option
              v-for="item in timeList"
              :key="item.label"
              :label="item.label"
              :value="item.label"
              size="small">
            </el-option>
          </el-select>
          <el-select
            v-model="form.hourEnd" filterable placeholder="请选择"
            style="width: 200px;" size="small">
            <el-option
              v-for="item in timeList2"
              :key="item.label"
              :label="item.label"
              :value="item.label"
              size="small">
            </el-option>
          </el-select>
        </div>
        <div class="form-item-div">
          <div class="form-item-text">
            排除放映日期
          </div>
          <!--          <el-select filterable allow-create v-model="form.notStartDateBegin" filterable placeholder="请选择"-->
          <!--                     style="width: 100%;" size="small">-->
          <!--            <el-option-->
          <!--              v-for="item in options"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <el-date-picker
            v-model="notStartDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            value-format="yyyy-MM-dd"
          @change="getNotStartDate">
          </el-date-picker>
        </div>
      </div>
      <div class="form-item flex">
        <div class="form-item-div">
          <div class="form-item-text">
            启用状态
          </div>
          <div class="form-item-input" style="margin-top: 20px">
            <el-radio v-model="form.status" :label="1">启用</el-radio>
            <el-radio v-model="form.status" :label="0">禁用</el-radio>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-button" @click="save">保存</div>
    </div>
  </div>
</template>

<script>
import {saasOrder} from "../../../../javaApi/saasOrder";

const SaasM = new saasOrder()
export default {
  name: "addRules",
  data() {
    return {
      value: [],
      radio: '',
      options: [],
      // 指派表单提交数据
      form: {
        id:'',
        ruleName: '',
        province: '',
        notProvince: '',
        city: '',
        notCity: '',
        movie: '',
        notMovie: {},
        seatCount: '',
        seatCountMax: '',
        seatEven: 0,
        containLove: 0,
        minMarketPrice: '',
        maxMarketPrice: '',
        cinemaName: '',
        notCinemaName: '',
        hallName: '',
        notHallName: '',
        showTime: '',
        fakeCinemaName: '',
        startDateBegin: '',
        startDateEnd: '',
        notStartDateBegin: '',
        notStartDateEnd: '',
        hourStart: '',
        hourEnd: '',
        status: 1,
      },
      type: '',
      message: {},
      cityList: [],
      provinceList: [],
      startDate:[],
      notStartDate:[],
      timeList:[{
        label:'0'
      },{
        label:'1'
      },{
        label:'2'
      },{
        label:'3'
      },{
        label:'4'
      },{
        label:'5'
      },{
        label:'6'
      },{
        label:'7'
      },{
        label:'8'
      },{
        label:'9'
      },{
        label:'10'
      },{
        label:'11'
      },{
        label:'12'
      }],
      timeList2:[{
        label:'13'
      },{
        label:'14'
      },{
        label:'15'
      },{
        label:'16'
      },{
        label:'17'
      },{
        label:'18'
      },{
        label:'19'
      },{
        label:'20'
      },{
        label:'21'
      },{
        label:'22'
      },{
        label:'23'
      },{
        label:'24'
      }]
    }
  },
  mounted() {
    this.type = this.$route.query.type
    if (this.type == 2) {
      this.form = this.$route.query.row
      console.log(this.form)
      if(this.form.startDateBegin){
        this.startDate.push(this.form.startDateBegin,this.form.startDateEnd)
      }
    this.form.maxMarketPrice = this.$route.query.row.maxMarketPriceBig
    this.form.minMarketPrice = this.$route.query.row.minMarketPriceBig
      if(this.form.notStartDateBegin){
        this.notStartDate.push(this.form.notStartDateBegin,this.form.notStartDateEnd)
      }
      console.log('this.form',this.form)
      console.log('this.form.status', this.form.status)
    }
    this.getCity()
    this.getProvince()
  },
  methods: {
    // 返回
    back() {
      this.$router.back()
    },
    save() {
      let param = {
        id:this.form.id,
        ruleName: this.form.ruleName,
        province: this.form.province,
        notProvince: this.form.notProvince,
        city: this.form.city,
        notCity: this.form.notCity,
        movie: this.form.movie,
        notMovie: this.form.notMovie,
        seatCount: this.form.seatCount,
        seatCountMax: this.form.seatCountMax,
        seatEven: this.form.seatEven,
        containLove: this.form.containLove,
        minMarketPrice: this.form.minMarketPrice,
        maxMarketPrice: this.form.maxMarketPrice,
        cinemaName: this.form.cinemaName,
        notCinemaName: this.form.notCinemaName,
        hallName: this.form.hallName,
        notHallName: this.form.notHallName,
        showTime: this.form.showTime,
        fakeCinemaName: this.form.fakeCinemaName,
        startDateBegin: this.form.startDateBegin,
        startDateEnd: this.form.startDateEnd,
        notStartDateBegin: this.form.notStartDateBegin,
        notStartDateEnd: this.form.notStartDateEnd,
        hourStart: this.form.hourStart,
        hourEnd: this.form.hourEnd,
        status: this.form.status,
      }
      // 因为修改要把数组转成字符串格式的才能提交
      if(param.notProvince){
        param.notProvince = param.notProvince.join(',')
      }
      if(param.cinemaName){
        param.cinemaName = param.cinemaName.join(',')
      }
      if(param.notCinemaName){
        param.notCinemaName = param.notCinemaName.join(',')
      }
      if(param.province){
        param.province = param.province.join(',')
      }
      if(param.city){
        param.city = param.city.join(',')
      }
      if(param.notCity){
        param.notCity = param.notCity.join(',')
      }
      if(param.movie){
        param.movie = param.movie.join(',')
      }
      if(param.notMovie){
        param.notMovie = param.notMovie.join(',')
      }
      if(param.hallName){
        param.hallName = param.hallName.join(',')
      }
      if(param.notHallName){
        param.notHallName = param.notHallName.join(',')
      }
      if(param.fakeCinemaName){
        param.fakeCinemaName = param.fakeCinemaName.join(',')
      }
      if (this.form.ruleName == '') {
        this.$Message.error('请输入规则名称')
        return
      }
      console.log('this.form.status',this.form.status)
      if (this.form.status === '') {
        this.$Message.error('请选择是否启用规则')
        return
      }
      if (this.type == 1) {
        SaasM.addRules(param).then(res => {
          if (res.data.code == 200) {
            this.$Message.success('新增成功')
            setTimeout(() => {
              this.$router.back()
            }, 1000)
          } else {
            this.$Message.error(res.data.info || res.data.message)
          }
        })
      } else {
        SaasM.updateRules(param).then(res => {
          if (res.data.code == 200) {
            this.$Message.success('修改成功')
            setTimeout(() => {
              this.$router.back()
            }, 1000)
          } else {
            this.$Message.error(res.data.info || res.data.message)
          }
        })
      }
    },
    getCity() {
      let params = {
        pageNo: 1,
        pageSize: 350
      }
      SaasM.getCity(params).then(res => {
        if (res.data.code == 200) {
          this.cityList = res.data.data.list
        } else {
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    getProvince() {
      SaasM.getProvince().then(res => {
        if (res.data.code == 200) {
          this.provinceList = res.data.data
        } else {
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    getStartDate(e){
      console.log(e)
      this.form.startDateBegin = e[0]
      this.form.startDateEnd = e[1]
    },
    getNotStartDate(e){
      this.form.notStartDateBegin = e[0]
      this.form.notStartDateEnd = e[1]
    }
  }
}
</script>

<style scoped lang="less">
.content-message {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;
  position: relative;
  padding-bottom: 60px;

  .top {
    display: flex;
    align-items: center;

    .back {
      width: 88px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      img {
        width: 24px;
        height: 24px;
      }

      .back-text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
      }
    }

    .title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 25px;
      margin-left: 20px;
    }
  }
}

.form {
  width: 70%;
  margin-top: 16px;
  margin-left: 80px;

  .form-item {
    margin-top: 24px;

    .form-item-div {
      width: 48%;
    }

    .form-item-text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      line-height: 20px;
      margin-bottom: 5px;
    }

    .form-item-input {
      display: flex;
      align-items: center;

      .text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-right: 8px;
      }
    }
  }
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon {
  margin: 0 8px;
}

.bottom {
  height: 60px;
  //background: #FFFFFF;
  border-radius: 0px 0px 8px 8px;
  position: fixed;
  bottom: 0;
  width: 96%;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  .bottom-button {
    width: 136px;
    height: 36px;
    background: #FF8622;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 36px;
    cursor: pointer;
  }
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

/deep/ .el-input__inner:focus {
  border-color: #FF8622 !important;
}

/deep/ .el-range-editor.is-active, .el-range-editor.is-active:hover {
  border-color: #FF8622 !important;
}

/deep/ .el-date-table td.today {
  background: #FF8622;
}

/deep/ .el-input__inner:hover {
  background: #FCF8F5;
  border-color: #FF8622 !important;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #FF8622 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/assignRules/addRules.vue